import { render } from "./SurveyTakerPostMessage.vue?vue&type=template&id=53680413"
import script from "./SurveyTakerPostMessage.vue?vue&type=script&lang=js"
export * from "./SurveyTakerPostMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__